
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/rating/rating.component.js'
      import type { DdsChangeEvent } from '../../events/events'
      export type { DdsChangeEvent } from '../../events/events'

      const tagName = 'dap-ds-rating'

      /**
 * `dap-ds-rating`
 * @summary Rating is a component that allows users to rate a product or service.
 * @element dap-ds-rating
 * @title - Rating
 *
 * @event {{ value: number }} dds-change - Event fired when the rating value changes.
 *
 * @csspart base - The main rating container.
 * @csspart star - The star element.
 * @csspart stars-container - The container of the stars.
 * @csspart icon - The icon of the star.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsChange: 'dds-change' as EventName<DdsChangeEvent>
        },
        displayName: "DapDSRating"
      })

      export default reactWrapper
    